/* eslint-disable */
const getters = {
  getAuthors(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
